import { useSEO } from "@/hooks/useSEO";
import { Button } from "@/components/ui/button";
import { Printer, ShieldCheck, Phone, Globe, MessageCircle } from "lucide-react";

export default function Flyer() {
  useSEO({ title: "Nassau Weekend Special — Printable Flyer", description: "Easy Drive Car Rental local weekend special flyer.", path: "/flyer", noindex: true });

  return (
    <div data-testid="flyer-page" className="max-w-4xl mx-auto px-6 lg:px-10 pt-36 pb-24">
      <div className="no-print mb-8 flex items-center justify-between flex-wrap gap-4">
        <p className="text-sm text-muted-foreground font-ui">Print this page (Letter or A4) to post at churches, schools and community boards — or choose “Save as PDF” to share digitally.</p>
        <Button data-testid="flyer-print-button" variant="outline" onClick={() => window.print()} className="rounded-full border-border bg-transparent hover:bg-black/5 hover:text-primary font-ui">
          <Printer size={15} className="mr-2" /> Print Flyer
        </Button>
        <a data-testid="flyer-social-download" href="/assets/local242-social.png" download="easy-drive-local242-social.png" className="inline-flex items-center text-sm font-ui font-semibold text-primary hover:underline underline-offset-4">
          Download social graphic (1080×1080) →
        </a>
      </div>

      <div className="print-area">
        <div
          data-testid="flyer-sheet"
          className="bg-white border border-border rounded-3xl overflow-hidden shadow-[0_16px_50px_rgba(0,0,0,0.08)]"
          style={{ WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }}
        >
          <div className="bg-[#C71E2E] text-white px-8 md:px-12 py-8 text-center">
            <img src="/logo.png" alt="Easy Drive Car Rental" className="h-14 mx-auto bg-white rounded-xl px-4 py-1.5" />
            <p className="mt-4 text-[11px] font-ui tracking-[0.35em] uppercase text-white/80">For our Nassau neighbours</p>
            <h1 className="mt-2 font-display text-4xl md:text-5xl tracking-tight">Nassau Weekend Special</h1>
            <p className="mt-2 font-ui text-sm text-white/85">Weekend errands · Airport runs · Family visiting · Your car in the shop</p>
          </div>

          <div className="px-8 md:px-12 py-10 text-center">
            <p className="font-ui text-xs tracking-[0.25em] uppercase text-muted-foreground">Use code at checkout</p>
            <p data-testid="flyer-code" className="mt-2 font-display text-6xl md:text-7xl tracking-[0.08em] text-[#C71E2E]">LOCAL242</p>
            <p className="mt-3 font-display text-2xl tracking-tight">10% off your rental</p>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-8">
              <div className="text-left space-y-2.5 text-sm font-ui text-foreground/85">
                <p className="flex items-center gap-2.5"><ShieldCheck size={15} className="text-[#C71E2E] shrink-0" /> Bahamian driver's license — no passport needed</p>
                <p className="flex items-center gap-2.5"><ShieldCheck size={15} className="text-[#C71E2E] shrink-0" /> 2-day minimum for local renters</p>
                <p className="flex items-center gap-2.5"><ShieldCheck size={15} className="text-[#C71E2E] shrink-0" /> Free delivery to your door — or pick up on West Bay Street</p>
                <p className="flex items-center gap-2.5"><ShieldCheck size={15} className="text-[#C71E2E] shrink-0" /> The price you see is the price you pay</p>
              </div>
              <div className="text-center shrink-0">
                <img src="/assets/qr-local242.png" alt="Scan to book with code LOCAL242" className="w-36 h-36 mx-auto rounded-xl border border-border" />
                <p className="mt-2 text-[11px] font-ui tracking-[0.2em] uppercase text-muted-foreground">Scan to book</p>
              </div>
            </div>

            <div className="mt-10 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-center gap-x-10 gap-y-2 text-sm font-ui text-foreground/80">
              <span className="flex items-center gap-2"><Phone size={14} className="text-[#C71E2E]" /> +1 (242) 813-1775</span>
              <span className="flex items-center gap-2"><MessageCircle size={14} className="text-[#C71E2E]" /> WhatsApp — we reply in minutes</span>
              <span className="flex items-center gap-2"><Globe size={14} className="text-[#C71E2E]" /> easydrivecarrental.com</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
